import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SignIn from './SignIn';
import Welcome from './welcome';      // <— your welcome.jsx
import Dashboard from './Dashboard';
import Monitor from './dashboard/monitor';
import Overview from './Overview';
import PremiumRedirect from './components/PremiumRedirect';
import CheckoutRedirect from './components/CheckoutRedirect';
import AuthProtectedRoute from './components/AuthProtectedRoute';
import PremiumProtectedRoute from './components/PremiumProtectedRoute';
import FrozenAccountProtectedRoute from './components/FrozenAccountProtectedRoute';
import ArchiveProtectedRoute from './components/ArchiveProtectedRoute';
import MessageTrace from './components/MessageTrace';
import Checkout from './Checkout';
import CheckoutTester from './CheckoutTester';
import Settings from './Settings';
import Archive from './Archive';
import AIVoiceDialer from './components/AIVoiceDialer';
import VoiceDialer2 from './components/VoiceDialer2';
import ContactsList from './components/ContactsList';
import AIAssistantManager from './components/AIAssistantManager';
import IntercomMessenger from './components/IntercomMessenger';

function App() {
  return (
    <Router>
      {/* Intercom Messenger - only initializes for authenticated users */}
      <IntercomMessenger />
      <Routes>
        {/* Public auth entrypoint */}
        <Route path="/" element={<SignIn />} />

        {/* Archive page - only accessible to archived users */}
        <Route path="/archive" element={
          <AuthProtectedRoute>
            <Archive />
          </AuthProtectedRoute>
        } />

        {/* Premium upsell / pricing page with premium redirect */}
        <Route path="/welcome" element={
          <ArchiveProtectedRoute>
            <AuthProtectedRoute>
              <PremiumRedirect>
                <Welcome />
              </PremiumRedirect>
            </AuthProtectedRoute>
          </ArchiveProtectedRoute>
        } />

        {/* Overview page - Premium Required */}
        <Route path="/overview" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <PremiumProtectedRoute>
                <Overview />
              </PremiumProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />

        {/* Protected dashboard - Premium Required */}
        <Route path="/dashboard" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <PremiumProtectedRoute>
                <Dashboard />
              </PremiumProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />
        
        {/* Monitor page - Premium Required */}
        <Route path="/dashboard/monitor" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <PremiumProtectedRoute>
                <Monitor />
              </PremiumProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />
        
        {/* Message Trace page - Premium Required */}
        <Route path="/dashboard/trace" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <PremiumProtectedRoute>
                <MessageTrace />
              </PremiumProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />

        {/* Checkout page */}
        <Route path="/checkout" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <AuthProtectedRoute>
                <CheckoutRedirect>
                  <Checkout />
                </CheckoutRedirect>
              </AuthProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />
        
        {/* Checkout Tester page */}
        <Route path="/checkout-tester" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <AuthProtectedRoute>
                <CheckoutTester />
              </AuthProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />
        
        {/* Settings page */}
        <Route path="/settings" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <AuthProtectedRoute>
                <Settings />
              </AuthProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />
        
        {/* AI Voice Dialer page - Premium Required */}
        <Route path="/voice-dialer" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <PremiumProtectedRoute>
                <AIVoiceDialer />
              </PremiumProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />
        
        {/* World Call page (Telnyx WebRTC) - Premium Required */}
        <Route path="/world-call" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <PremiumProtectedRoute>
                <VoiceDialer2 />
              </PremiumProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />
        
        {/* Contacts page - Premium Required */}
        <Route path="/contacts" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <PremiumProtectedRoute>
                <ContactsList />
              </PremiumProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />
        
        {/* AI Assistant Manager page - Premium Required (Hidden from navigation) */}
        <Route path="/ai-assistant" element={
          <ArchiveProtectedRoute>
            <FrozenAccountProtectedRoute>
              <PremiumProtectedRoute>
                <AIAssistantManager />
              </PremiumProtectedRoute>
            </FrozenAccountProtectedRoute>
          </ArchiveProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;